/**
 * Created by baijing on 2018/5/29.
 */

var route = {
    path : '/changePwdTermly',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/ChangePwdTermly.jsx').default)
        }, 'changePwdTermly')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/changePwdTermly.js